// PreviewModal.js
import React from 'react';
import './PreviewModal.css';

const isLikelyHtml = (s = "") => {
    const t = s.trim().toLowerCase();
    return t.startsWith("<!doctype html") || t.startsWith("<html") || t.includes("<body");
};

const isDataImage = (s = "") => s.startsWith("data:image");

const isPdfUrl = (s = "") =>
    typeof s === "string" &&
    (s.endsWith(".pdf") || s.includes("application/pdf") || s.includes(".pdf?"));

const PreviewModal = ({ title, previewContent, previewType, previewError, downloadUrl, onClose }) => {
    const normalizedType = (previewType || "").toLowerCase();
    const renderDownloadAction = () => downloadUrl ? (
        <a className="preview-download-button" href={downloadUrl} target="_blank" rel="noreferrer" download>
            Open / Download Original
        </a>
    ) : null;

    return (
        <div className="preview-modal">
            <div className="preview-modal-content" style={{ width: "min(1000px, 95vw)", height: "80vh" }}>
                <button className="close-button" onClick={onClose}>×</button>
                <div className="preview-modal-header">
                    <h3>Preview: {title}</h3>
                    {renderDownloadAction()}
                </div>

                {previewError ? (
                    <div className="preview-error-state">
                        <p>{previewError}</p>
                        {renderDownloadAction()}
                    </div>
                ) : !previewContent ? (
                    <p>Loading preview...</p>
                ) : normalizedType === "image" || isDataImage(previewContent) ? (
                    <div className="preview-container" style={{ height: "calc(100% - 48px)", overflow: "auto" }}>
                        <img src={previewContent} alt="Preview" style={{ maxWidth: "100%", height: "auto", display: "block", margin: "0 auto" }} />
                    </div>
                ) : normalizedType === "html" || isLikelyHtml(previewContent) ? (
                    <iframe
                        title="Document Preview"
                        sandbox="allow-same-origin allow-popups allow-top-navigation-by-user-activation"
                        style={{ width: "100%", height: "calc(100% - 48px)", border: 0, background: "#fff" }}
                        srcDoc={previewContent}
                    />
                ) : normalizedType === "pdf" || isPdfUrl(previewContent) ? (
                    <iframe
                        title="PDF Preview"
                        style={{ width: "100%", height: "calc(100% - 48px)", border: 0 }}
                        src={previewContent}
                    />
                ) : (
                    <pre className="preview-container" style={{ whiteSpace: "pre-wrap", height: "calc(100% - 48px)", overflow: "auto", margin: 0 }}>
            {previewContent}
          </pre>
                )}
            </div>
        </div>
    );
};

export default PreviewModal;
